/* eslint-disable no-undef */
import axios from 'axios';
import ApiList from './api';
import getPkce from 'oauth-pkce';
import useCookie from './useCookie';

const scope = 'vms.all';
const codeVerifierLocalStorageKey = 'plainVerifier';
const authServer = () => config.authServer;
const clientId = () => config.clientId;
const redirectUri = () => config.redirectUri;
const { setCookie, getCookie, removeCookie} = useCookie(); 

export async function rerouteToOAuthLogin() { // reroute to login panel that redirects back to the web app with an authorization code
  const { verifier, challenge } = await new Promise((resolve) => {
    getPkce(43, (error, { verifier, challenge }) => {
      if (error) throw error;
      resolve({ verifier, challenge });
    });
  });
  window.localStorage.setItem(codeVerifierLocalStorageKey, verifier);
  window.location.href =
  `${authServer()}/oauth2/authorize?client_id=${clientId()}&redirect_uri=${redirectUri()}&response_type=code&code_challenge=${challenge}&code_challenge_method=S256&scope=${scope}`;
}

export async function getToken(code) { // https://datatracker.ietf.org/doc/html/rfc6749#section-4.1.3
  const params = {
    grant_type: 'authorization_code',
    client_id: clientId(),
    code: code,
    code_verifier: localStorage.getItem(codeVerifierLocalStorageKey),
    redirect_uri: redirectUri()
  }
  const axiosConfig = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, params }
  try {
    const response = await axios.post(`${authServer()}/oauth2/token`, null, axiosConfig);
    if (response.code === 302 && response.headers.location) {
      window.location.href = response.headers.location;
    } else {
      ApiList.token = response.data.access_token;
      setAuthCookie(response.data.access_token, response.data.expires_in + 's');
      localStorage.removeItem(codeVerifierLocalStorageKey);
    }
  } catch (error) {
    console.log(error);
  }
}

export async function getJwtFromExchangeToken(exchangeToken) {
  try {
    const response = await axios.get(`${authServer()}/api/v3.0/oneTimeCodes/${exchangeToken}`);
    ApiList.token = response.data.accessToken;
    const startDate = new Date().getTime();
    const endDate = new Date(response.data.expireTimestamp).getTime();
    const expiry = Math.floor((endDate - startDate) / 1000) + 's';
    setAuthCookie(response.data.accessToken, expiry);
    return response;
  } catch (error) {
    console.log(error);
  }
  return undefined;
}

export async function logOut() {
  const cachedAuthKey = authKey();
  try {
    await axios.post(`/oauth2/revoke?token=${cachedAuthKey}`, null, {
      baseURL: authServer(),
    });
    removeCookie("access_token");
    removeCookie("auth_key");
    removeCookie("root_url");
    rerouteToOAuthLogin();
  } catch (error) {
    console.log(error);
  }
}

export function authKey() {
  return getCookie('access_token');
}

export function plainAuthKey() {
  return getCookie('auth_key');
}

function setAuthCookie(accessToken, expiry) {
  setCookie('access_token', accessToken, expiry, '/');
  // set the basic auth_key
  const tokenDecodablePart = parseJwt(accessToken);
  const plainAuthToken = tokenDecodablePart.vms_cluster + '~' + tokenDecodablePart.jti;
  ApiList.plainAuthToken = plainAuthToken;
  setCookie('auth_key', plainAuthToken, expiry, '/', true, 'None');
}

function parseJwt(token) {
  try {
    const base64HeaderUrl = token.split('.')[0];
    const base64Header = base64HeaderUrl.replace('-', '+').replace('_', '/');
    const headerData = JSON.parse(window.atob(base64Header));
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const dataJWT = JSON.parse(window.atob(base64));
    dataJWT.header = headerData;
    return dataJWT;
  } catch (err) {
    return false;
  }
}